<template>
  <div class="table-responsive">
    <table class="table table-sm first-td-padding table-bordered">
      <thead>
        <tr>
          <th v-for="field in fields" v-bind:key="'field'+field.title">{{field.title}}</th>
          <th v-if="actions">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row,index) in fillableData" v-bind:key="'row'+index">
          <td v-for="field in fields" v-bind:key="field.name+index">{{row[field.name]}}</td>
          <td v-if="actions">
            <div class="action-btn-wrapper">
              <a
                style="margin:1px 4px"
                class="btn btn-sm btn-small"
                :class="action.btnClass"
                v-for="action in actions"
                v-bind:key="'action'+action.tooltip"
                @click.prevent="action.callback(row,index,$event)"
              >
                <i :title="action.tooltip" class="fa" :class="action.icon"></i>
              </a>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot v-if="fillableData.length==0">
        <tr>
          <td :colspan="(fields.length+actions.length)">
            <i class="fa fa-info cwhite"></i> No data found.
          </td>
        </tr>
      </tfoot>
    </table>
    <div class="pull-right">
      <ul v-if="this.totalPages != 1" class="pagination">
        <li :class="{disabled:prevDisabled}" class="page-item">
          <a class="page-link" @click.prevent="prev()" href="#">{{'<<'}}</a>
        </li>
        <li
          v-for="page in pages"
          v-bind:key="page"
          class="page-item"
          :class="(current_page == page)? 'active':''"
        >
          <a class="page-link" @click.prevent="goToPage(page)" href="#">{{page}}</a>
        </li>
        <li :class="{disabled:nextDisabled}" class="page-item">
          <a class="page-link" href="#" @click.prevent="next()">{{'>>'}}</a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import {eventHub} from '../main'
export default {
  created() {
    this.url = this.apiUrl;
    console.log(this.url.indexOf("companiesListing"), this.$route.query);
    // if (this.url.indexOf("companiesListing") != -1) this.url += this.pageToLoad;
    this.$route.query.page
      ? (this.pageToLoad = parseInt(this.$route.query.page))
      : (this.pageToLoad = '1');
    this.url += this.pageToLoad;
    this.current_page = this.pageToLoad;
    console.log("this.searchParams", this.searchParams);
    this.fetchData(this.searchParams);
    this.setActions();
  },
  name: "vtable",
  props: {
    fields: { default: [] },
    apiUrl: {},
    data: {},
    actions: {},
    paginate: { default: true },
    reload: {}
  },
  watch: {
    reload() {
      this.fillTable();
    },
    $route(to, from) {
      this.pageToLoad = to.query.page;
      console.log("watch route", to.query);
      // this.fetchData(to.query)
    }
  },
  data() {
    return {
      isLoading: true,
      fillableData: [],
      url: "",
      current_page: 1,
      pageToLoad: 1,
      totalPages: 1,
      prevDisabled: 1,
      nextDisabled: 0,
      pages: []
    };
  },
  methods: {
    setActions() {},
    fetchData(data, pageNo) {
      if (this.url !== "") {
        console.log("=====" + this.url + "========");
        let myself = this;
        let params = data
          ? { companyname: data.companyname, sectorname: data.sectorname }
          : {};
        http.post(this.url, params, function(error, response) {
          console.log(response);
          if (!error) {
            myself.fillableData = response.data;
            myself.current_page = myself.pageToLoad;
            myself.totalPages = response.total_pages;
            myself.prevDisabled = myself.pageToLoad == 1;
            myself.nextDisabled = myself.current_page == myself.totalPages;
            myself.isLoading = false;
            // set 5 pages to show
            console.log("current", myself.current_page);
            let i = 5;
            let page = myself.current_page - 2;
            if (page <= 0) page = 1;
            myself.pages = [];
            while (i) {
              myself.pages.push(parseInt(page));
              if (myself.totalPages <= page) break;
              page++;
              i--;
            }
            console.log("PAges", myself.pages);
          } else {
            console.log(error);
          }
        });
      } else {
        console.log("=====" + this.url + "========");
      }
    },
    prev() {
      this.pageToLoad = this.current_page - 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    goToPage(page) {
      this.pageToLoad = page;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    next() {
      console.log(this.$route.query);
      this.pageToLoad = this.current_page + 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    fillTable() {
      let url = this.apiUrl; //+"?a=1"
      if (this.pageToLoad != this.current_page) url += this.pageToLoad;
      this.url = url;
      this.fetchData();
    },
    remove(index) {
      this.fillableData.splice(index, 1);
    },
    searchIn(searchParams) {
      console.log("Searchparams from child", searchParams);
      let params = searchParams
        ? {
            companyname: searchParams.companyname,
            sectorname: searchParams.sectorname
          }
        : {};
      this.fetchData(params);
    }
  },
  mounted(){
    eventHub.$on('customEventName', this.fetchData({}))
  }
};
</script>



// WEBPACK FOOTER //
// src/components/vtable.vue